const INVOICES_GETTERS = {
  loading: 'invoices/loading',
  actionLoading: 'invoices/actionLoading',
  pollingLoading: 'invoices/pollingLoading',
  items: 'invoices/items',
  sorting: 'invoices/sort',
  chronologySort: 'invoices/chronologySort',
  search: 'invoices/search',
  page: 'invoices/page',
  total: 'invoices/total',

  statusFilter: 'invoices/statusFilter',
  dateFromFilter: 'invoices/dateFromFilter',
  dateToFilter: 'invoices/dateToFilter',
  dateRange: 'invoices/dateRange',
  isOneTimeFilter: 'invoices/isOneTimeFilter',
  isUnfixedAmountFilter: 'invoices/isUnfixedAmountFilter',
  statistics: 'invoices/statistics',
}

const INVOICES_DISPATCHERS = {
  createInvoice: 'invoices/createInvoice',
  duplicateInvoice: 'invoices/duplicateInvoice',
  onSearch: 'invoices/onSearch',
  getInvoices: 'invoices/getInvoices',
  getInvoiceById: 'invoices/getInvoiceById',
  getInvoiceDetailsPolling: 'invoices/getInvoiceDetailsPolling',
  resetStore: 'invoices/resetStore',
  changePage: 'invoices/changePage',
  onSelectSort: 'invoices/onSelectSort',
  onSelectChronologySort: 'invoices/onSelectChronologySort',
  deleteInvoices: 'invoices/deleteInvoices',
  resetSearch: 'invoices/resetSearch',
  cancelInvoice: 'invoices/cancelInvoice',

  setStatusFilter: 'invoices/setStatusFilter',
  setDateFromFilter: 'invoices/setDateFromFilter',
  setDateToFilter: 'invoices/setDateToFilter',
  setDateRange: 'invoices/setDateRange',
  setIsOneTimeFilter: 'invoices/setIsOneTimeFilter',
  setIsUnfixedAmountFilter: 'invoices/setIsUnfixedAmountFilter',
  resetFilters: 'invoices/resetFilters',
  getInvoiceLink: 'invoices/getInvoiceLink',
}

export { INVOICES_GETTERS, INVOICES_DISPATCHERS }
